import { render } from "./projectemployerviewproposal.vue?vue&type=template&id=eea1b6a8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__